import React from "react";
import LandingNavbar   from "../components/landing/LandingNavbar";
import HeroSection     from "../components/landing/HeroSection";
import SocialProof     from "../components/landing/SocialProof";
import HowItWorks      from "../components/landing/HowItWorks";
import FeaturesGrid    from "../components/landing/FeaturesGrid";
import AudienceSection from "../components/landing/AudienceSection";
import PricingSection  from "../components/landing/PricingSection";
import TrustSection    from "../components/landing/TrustSection";
import BottomCTA       from "../components/landing/BottomCTA";
import Footer          from "../components/layout/Footer";
import "../styles/landing.css";

export default function LandingPage() {
  return (
    <div className="landing-root">
      <LandingNavbar />
      <HeroSection />
      <SocialProof />
      <HowItWorks />
      <FeaturesGrid />
      <AudienceSection />
      <PricingSection />
      <TrustSection />
      <BottomCTA />
      <Footer />
    </div>
  );
}
